import { useState, useMemo, useEffect } from "react";
import "./blogs.css";

const Blogs = () => {
  const [blogList, setBlogList] = useState([]); // State to hold the fetched data
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    document.title = "Travel Blogs | Insights by Mango Holidays";

    // Fetch the JSON file from the public folder
    const fetchBlogs = async () => {
      try {
        // Because it's in the public folder, we can access it from the root URL
        const response = await fetch("/BlogsData.json");
        if (!response.ok) {
          throw new Error("Failed to fetch blog data");
        }
        const data = await response.json();
        setBlogList(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error loading blogs:", error);
        setIsLoading(false);
      }
    };

    fetchBlogs();
  }, []); // Empty dependency array means this runs once on mount

  // Dynamically generate categories from the fetched data
  const categories = ["All", ...new Set(blogList.map((blog) => blog.category))];

  // Filter and sort blogs
  const filteredBlogs = useMemo(() => {
    return blogList
      .filter((blog) => {
        const matchesCategory =
          selectedCategory === "All" || blog.category === selectedCategory;

        const matchesSearch =
          blog.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          blog.subtitle.toLowerCase().includes(searchQuery.toLowerCase());

        return matchesCategory && matchesSearch;
      })
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [searchQuery, selectedCategory, blogList]);

  return (
    <>
      <section className="banner-section-blogs">
        <div className="img-container-blogs">
          <img src="/img/Andaman.webp" alt="Banner Unavailable" />
        </div>
        <div className="banner-overlay-blogs">
          <h1 className="banner-title-blogs">Blogs</h1>
        </div>
      </section>

      <section className="blog-filters-section">
        <div className="search-container">
          <input
            type="text"
            placeholder="Search blogs..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="category-container">
          {categories.map((category) => (
            <button
              key={category}
              className={selectedCategory === category ? "active" : ""}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </section>

      <section className="blog-section">
        <div className="blog-grid">
          {isLoading ? (
            <p>Loading blogs...</p>
          ) : filteredBlogs.length === 0 ? (
            <p className="no-blogs">No blogs found matching your criteria.</p>
          ) : (
            filteredBlogs.map((blog) => (
              <div key={blog.id} className="blog-card">
                <div className="blog-image-container">
                  <div className="blog-image">
                    <img src={blog.background_image} alt={blog.title} />
                  </div>
                  <p className="blog-date">
                    <i className="fa fa-calendar-alt" /> {blog.date}
                  </p>
                </div>

                <div className="blog-content">
                  <h2>
                    <a
                      href={blog.fileUrl}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {blog.title}
                    </a>
                  </h2>
                  <p>{blog.subtitle}</p>

                  <div className="button-container">
                    <a
                      href={blog.fileUrl}
                      className="btn-c"
                      style={{
                        textDecoration: "none",
                        display: "inline-block",
                        textAlign: "center",
                      }}
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </section>
    </>
  );
};

export default Blogs;
